<template>
  <v-app class="entrada-salida">
    <header class="pl-16 v-app-bar">
      <div class="v-toolbar__content transparent" style="height: 56px;">
        <v-btn class="back white" icon large @click="goBack()">
          <v-icon class="icon atras"></v-icon>
        </v-btn>
        <v-row>
          <div elevation="0" class="pl-0 header-icon">
            <v-icon :class="['icon', isSalida ? 'caja' : 'caja-out']"></v-icon>
          </div>
        </v-row>
        <div class="d-flex align-center pr-4 pl-14">
          <!-- <v-text-field class="buscar ml-7 pt-0" hide-details clearable text ref="buscador" label="Buscar / Añadir" v-model="buscador" @click:clear="clearBuscador()"></v-text-field> -->
          <v-text-field class="buscar ml-7 pt-0" hide-details clearable text ref="buscador" label="Buscar"
            v-model="buscador" @click:clear="clearBuscador()"></v-text-field>
          <v-icon class="icon search" icon large> </v-icon>
          <v-text-field class="buscar pt-4" style="opacity: 0; width: 0px;" id="textEan" text ref="textEan" label="Ean"
            v-model.lazy.trim="ean" @keydown.enter="searchByEanCode()"></v-text-field>
        </div>
      </div>
    </header>
    <Menu />
    <v-main class="mt-14 d-flex flex-column">
      <EanReader :tipo.sync="tipoLectura" @scan="onEanScanned" />
      <v-card class="d-flex flex-wrap align-center py-3 text-h6 font-weight-regular" v-if="!entradaSalidaManual">
        <div class="d-flex flex-grow-1 overflow-hidden">
          <template v-if="isAlbaran">
            <v-list-item-avatar class="accent my-0 ml-4">
              <v-icon dark> mdi-file-document-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="primary--text">
                <span class="" v-text="isSalida ? albaran.odt_codigo : albaran.albaran_codigo"></span>
                <span class="font-weight-bold ml-1 text-truncate" v-text="albaran.origen_cod + '-' + albaran.origen_nombre"></span>
              </v-list-item-title>
              <v-list-item-subtitle class="accent--text"><span class="font-weight-black "
                  v-text="albaran.albaran_referencia"></span></v-list-item-subtitle>
              <p class="font-weight-light mb-0 pa-0 caption d-flex text-truncate">{{ isSalida ? albaran.odt_fecha : albaran.albaran_fecha }}</p>
            </v-list-item-content>
          </template>
          <template v-else>
            <v-list-item-avatar class="accent my-0 ml-4">
              <v-icon dark>mdi-archive-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="primary--text">SSCC<span class="font-weight-black  pl-1">
                  {{ albaran.barcode }}</span></v-list-item-title>
              <v-list-item-subtitle
                class="accent--text font-weight-medium mb-0 pa-0 d-flex text-truncate text-overline">{{ albaran.origen_cod + '-' + albaran.origen_nombre }}
              </v-list-item-subtitle>
              <p class="font-weight-light mb-0 pa-0 caption d-flex text-truncate">{{ albaran.albaran_fecha }}</p>
            </v-list-item-content>
          </template>
          <v-btn @click="expandirContraer()" icon class="justify-content-end mr-2"  color="primary lighten-1">
            <v-icon v-if="expandir">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </div>
        <v-switch
          class="ml-5 mr-auto"
          v-model="verDiff"
          color="primary"
          inset
          hide-details
          label="Marcar diferencias"
          @change="marcarDiferencias()"
        ></v-switch>
        <div class="primary--text mb-0 pt-3 mx-3 text-truncate"><v-label>Leído: </v-label>{{totalLeido}}<span class="accent--text">/{{totalInicial}}</span></div>
      </v-card>
      <div v-if="cargando" class="mt-15 text-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <v-card v-else class="scroll-order" :key="keyRefresh">
        <v-expansion-panels accordion multiple v-model="openedPanel" class="mt-0">
          <v-expansion-panel v-for="(item, i) in lineas" :key="i" ref="articulos" :id="i">
            <v-expansion-panel-header class="px-4 py-2">
              <v-img :src="Object.keys(fotos).length > 0 ? fotos[i] !== undefined ? fotos[i].url : '' : ''"
                class="pr-4" max-height="80" max-width="90" contain> </v-img>
              <v-list-content class="d-flex pa-0 flex-column justify-start align-start">
                <v-list-item-title class="align-self-start my-1 font-weight-bold primary--text pa-0 text-uppercase">{{
                  item[0].modelo }}
                </v-list-item-title>
                <v-list-item-subtitle class="font-weight-medium mb-3 accent--text pa-0 d-flex">{{ item[0].localizador
                  }}</v-list-item-subtitle>
                <p class="font-weight-light mb-0 pa-0 caption d-flex text-truncate">{{ item[0].color }}</p>
              </v-list-content>
              <v-btn @click="eliminarArticulo(i)" icon class="ml-auto" color="primary lighten-1" v-if="item[0].added">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
              <!-- Este cuando todos están escaneados
              <v-icon color="success">mdi-check-circle</v-icon>
              -->
              <!-- Este cuando todos están escaneados
              <v-icon color="secondary">mdi-close-circle</v-icon>
              -->
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="d-flex justify-start ma-0 stock-table">
                <v-col class="d-flex pa-0 flex-column align-center jusitify-start flex-grow-0"
                  v-for="(talla, y) in item" :key="y + 'a'">
                  <p class="text-no-wrap px-2 py-1 text-body-2 font-weight-medium primary--text mb-0 text-center"
                    v-text="talla.talla"></p>
                  <p v-if="!entradaSalidaManual" class="pl-2 pr-7 text-no-wrap mb-0 text-center grey--text text--darken-2" v-once
                    v-text="(talla.unidInicial != undefined) ? talla.unidInicial : talla.unid"></p>
                  <v-text-field class="pt-0 text-h6 text-center" :ref="talla.eans[0]" label="Stock" :value="talla.unid"
                    v-model.number="talla.unid" @focus="$event.target.select()" @input="(verDiff) ? marcarDiferencias() : null" type="number">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
      <div class="hueco py-8 mt-auto"></div>

      <v-bottom-sheet v-model="sheet" v-if="entradaSalidaManual">
        <v-sheet class="text-center py-5 px-3 inventory-sheet">
          <v-btn @click="isSalida ? verificarSalida() : verificarEntrada()" right fixed fab bottom class="secondary" elevation="0">
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
          <template v-if="isSalida">
            <h2 class="button text-uppercase text-left primary--text ml-2 font-weight-bold pb-3 mt-2">Selecciona el destino</h2>
            <v-autocomplete
              class="justify-center mx-4 mt-0 pb-15"
              label="Tienda"
              :items="shops"
              color="accent"
              prepend-inner-icon="mdi-map-marker"
              :item-text="isSys4Conjunto() ? 'clicode' : 'nombre'"
              :item-value="(item) => item"
              return-object
              v-model="tiendaDestino"
            ></v-autocomplete>
          </template>
          <template v-else>
            <h2 class="button text-uppercase text-left primary--text ml-2 font-weight-bold pb-3 mt-2">Selecciona el origen</h2>
            <v-autocomplete
              class="justify-center mx-4 mt-0 pb-15"
              label="Tienda"
              :items="shops"
              color="accent"
              prepend-inner-icon="mdi-map-marker"
              :item-text="isSys4Conjunto() ? 'clicode' : 'nombre'"
              :item-value="(item) => item"
              return-object
              v-model="tiendaOrigen"
            ></v-autocomplete>
          </template>
        </v-sheet>
      </v-bottom-sheet>
    </v-main>
      <!-- <v-btn class="accent rounded-0" text fixed bottom left @click="borrarEntrada()"
        v-if="Object.keys(lineas).length > 0">
        <v-icon class="mr-2" color="white">mdi-cancel</v-icon> Reiniciar
      </v-btn> -->
      <v-btn class="accent rounded-0" text fixed bottom left @click="autoCompletar()"
        v-if="!entradaSalidaManual && Object.keys(lineas).length > 0">
        <v-icon class="mr-2" color="white">mdi-content-copy</v-icon> Autocompletar
      </v-btn>
      <v-btn class="secondary rounded-0 elevation-0" fixed  bottom right @click="(!entradaSalidaManual ? isSalida ? verificarSalida() : verificarEntrada() : sheet = true)"
        v-if="Object.keys(lineas).length > 0">
        <v-icon class="mr-1 " color="white">mdi-send-variant-outline</v-icon>Enviar
      </v-btn>
    <!-- Modal numero de bultos de la salida -->
    <v-dialog persistent v-model="dialogBultos" max-width="290" @keydown.esc="dialogBultos = false">
      <v-card>
        <v-toolbar dark color="primary" dense flat>
          <v-toolbar-title class="white--text">Bultos</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle class="subheading pt-3">Indica el número de bultos de la salida</v-card-subtitle>
        <v-card-text class="d-flex align-center justify-center pb-0">
          <v-btn icon large color="primary" :disabled="numBultos <= 1" @click="numBultos--">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
          <v-text-field class="mx-2 text-h6 text-center" style="max-width: 80px;" :value="numBultos" readonly outlined dense hide-details></v-text-field>
          <v-btn icon large color="primary" @click="numBultos++">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogBultos = false">Cancelar</v-btn>
          <v-btn color="secondary" @click="confirmarBultos()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <!-- Canvas para generar códigos de barras -->
    <canvas ref="barcodeCanvas" style="display: none;"></canvas>
    <!-- Etiqueta PDF: una por bulto, cada una en su pagina -->
    <div id="etiqueta-pdf" style="display:none; font-family:Arial,sans-serif; font-size:11pt; width:100%;">
      <div v-for="(etiqueta, index) in etiquetas" :key="etiqueta.sscc" :style="{ pageBreakBefore: index > 0 ? 'always' : 'auto' }"
        style="border:1px solid #000; box-sizing:border-box; padding-top:14px; display:flex; flex-direction:column;">
        <!-- Origen -->
        <div style="margin:2px; border:1px solid #000; position:relative;">
          <div style="border-left:1px solid #000; padding:8px 35px; position:relative;">
            <h4 style="transform:rotate(-90deg); transform-origin:left top; position:absolute; top:79%; left: 0px; margin:0; font-weight:bold;">Origen</h4>
            <p style="margin:0; font-weight:500; text-transform:uppercase;">{{clicode}} {{detalleTienda(opId).nombre}}</p>
            <p style="margin:0; font-size:10pt;">{{detalleTienda(opId).calle}}</p>
            <div style="display:flex;">
              <h5 style="margin:0 0 4px 0; font-weight:500; text-transform:uppercase;">{{detalleTienda(opId).poblacion}}</h5>
              <!-- De momento no tengo el telefono del op comunicado a la tienda -->
              <!-- <h5 style="margin:0 0 4px 20px;">
                <span style="font-size:10pt;">Telef.:</span>
                <span style="font-weight:500;">934440237</span>
              </h5> -->
            </div>
          </div>
        </div>

        <!-- Destino -->
        <div style="margin:2px; border:1px solid #000; position:relative;">
          <div style="border-left:1px solid #000; padding:12px 35px; position:relative;">
            <h3 style="transform:rotate(-90deg); transform-origin:left top; position:absolute; top:82%; left:-2px; margin:0; font-weight:bold;">Destino</h3>
            <h3 style="margin:0; font-weight:bold; text-transform:uppercase;">{{detalleTienda(tiendaDestino.id).clicode}} {{detalleTienda(tiendaDestino.id).nombre}}</h3>
            <p style="margin:0; font-weight:500; font-size:10pt;">{{detalleTienda(tiendaDestino.id).calle}}</p>
            <div style="display:flex;">
              <h4 style="margin:0 0 4px 0; text-transform:uppercase; font-weight:bold;">{{detalleTienda(tiendaDestino.id).poblacion}}</h4>
              <!-- De momento no tengo el telefono del op comunicado a la tienda -->
              <!-- <h4 style="margin:0 0 4px 20px;">
                <span style="font-size:10pt;">Telef.:</span>
                <span style="font-weight:bold;">902480902</span>
              </h4> -->
            </div>
          </div>
        </div>

        <!-- Código y Info -->
        <div style="display:flex; padding-bottom:20px; padding-top:12px;">
          <div style="padding:0 16px; max-width:60%;">
            <p style="margin:0 0 10px 0;" v-if="isAlbaran" >
              <span style="display:block; font-size:10pt; line-height:10px;">Odt</span>
              <span style="font-weight:bold;">{{ albaran.odt_codigo }}</span>
            </p>
            <p style="margin:0 0 10px 0;">
              <span style="display:block; font-size:10pt; line-height:10px;">SSCC</span>
              <!-- <span style="font-weight:bold;">{{barcode}}</span> -->
            </p>
            <img :src="etiqueta.img" style="width:300px; max-width:100%; height:auto;" />
          </div>
          <div style="flex-grow:1; padding-right:16px;">
            <p style="margin:0 0 10px 0;"><span style="display:block; font-size:10pt;">Portes</span><span style="font-weight:bold;">Pagados</span></p>
            <p style="margin:0 0 10px 0;"><span style="display:block; font-size:10pt;">Bulto</span><span style="font-weight:bold;">{{ index + 1 }} de {{ etiquetas.length }}</span></p>
            <!-- <p style="margin:0 0 10px 0;"><span style="display:block; font-size:10pt;">Peso</span><span style="font-weight:bold;">-</span></p> -->
            <p style="margin:0 0 10px 0;"><span style="display:block; font-size:10pt;">Fecha</span><span style="font-weight:bold;">{{hoy()}}</span></p>
            <!-- <p style="margin:0 0 10px 0;"><span style="display:block; font-size:10pt;">Observaciones</span><span style="font-weight:bold;">-</span></p> -->
          </div>
        </div>

        <!-- Resumen -->
        <div style="padding-top:20px; padding-left:20px; padding-right:20px; border-top:1px solid #000;">
          <!-- <h2 style="margin:0 0 12px 0;">
            <span style="display:block; font-size:10pt;">Nº pedido</span>
            <span style="font-weight:bold;">200/27.161</span>
          </h2> -->
          <!-- <div style="display:flex; padding-bottom:16px;">
            <p style="margin:0 20px 0 0;"><span style="display:block; font-size:10pt;">Fecha</span><span style="font-weight:bold;">14/04/2025</span></p>
            <p style="margin:0 20px 0 0;"><span style="display:block; font-size:10pt;">Bultos</span><span style="font-weight:bold;">1 de 1</span></p>
            <p style="margin:0;"><span style="display:block; font-size:10pt;">Comentario</span><span style="font-weight:bold;">-</span></p>
          </div> -->

          <!-- Tabla -->
          <table style="width:100%; border-collapse:collapse; table-layout:fixed;">
            <tr>
              <th style="text-align:left; border-bottom:2px solid #000; padding:4px;">Modelo</th>
              <th style="text-align:left; border-bottom:2px solid #000; padding:4px;">Localizador</th>
              <th style="text-align:left; border-bottom:2px solid #000; padding:4px;">Color</th>
              <th style="text-align:left; border-bottom:2px solid #000; padding:4px;">Talla</th>
              <th style="text-align:left; border-bottom:2px solid #000; padding:4px;">Und.</th>
            </tr>

            <section class="contenedor-neutro" v-for="(item, i) in lineas" :key="i + 'b'">
              <section class="contenedor-neutro" v-for="(talla, y) in item" :key="y + 'z'">
                <tr v-if="talla.unid > 0">
                  <td style="padding:4px;">{{ item[0].modelo }}</td>
                  <td style="padding:4px;">{{ item[0].localizador }}</td>
                  <td style="padding:4px;">{{ item[0].color }}</td>
                  <td style="padding:4px;">{{ talla.talla }}</td>
                  <td style="padding:4px;">{{ talla.unid }}</td>
                </tr>
              </section>
            </section>
            <tr>
              <td style="padding:4px;"></td>
              <td style="padding:4px;"></td>
              <td style="padding:4px;"></td>
              <td style="padding:4px; font-weight:bold;">TOTAL</td>
              <td style="padding:4px; font-weight:bold;">{{ total }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import Menu from '../../components/Menu.vue';
import EanReader from '../../components/EanReader.vue';
import JsBarcode from 'jsbarcode';
import html2pdf from "html2pdf.js";

import { AlbaranApiService } from '../../api/AlbaranApiService';
const albaranApiService = new AlbaranApiService();
import { TiendaApiService } from '../../api/TiendaApiService';
const tiendaApiService = new TiendaApiService();
import { OpsApiService } from '../../api/OpsApiService';
const opsApiService = new OpsApiService();

export default Vue.extend({
  name: 'AlbaranDetalle',
  components: {
    Menu,
    EanReader,
  },
  props: {
    uid: {
      type: String,
      required: false,
    },
    modo: {
      type: String,
      default: 'entrada',
    },
  },
  data: () => ({
    ean: '',
    audioError: new Audio(require('@/assets/sonidos/error.mp3')),
    audioOk: new Audio(require('@/assets/sonidos/ok.mp3')),
    cargando: false,
    opUid: '',
    opId: '',
    clicode: '',
    lineas: {},
    albaran: {},
    fotos: {},
    buscador: '',
    openedPanel: [],
    isAlbaran: null,
    keyRefresh: 0,
    expandir: false,
    tipoLectura: 0, //0->pistola 1->camara 2-> manual
    verDiff: false,
    hayDiferencias: false,
    totalLeido: 0,
    totalInicial: 0,
    entradaSalidaManual: false,
    uidEntrada: '',
    sheet: false,
    shops: [],
    tiendaDestino: {
      id: '',
      nombre: '',
      calle: '',
      cp: '',
      localidad: '',
      provincia: ''
    },
    tiendaOrigen: {
      id: '',
      nombre: '',
      opuid: '',
      wsid: '',
      clicode: '',
      poblacion: '',
      calle: ''
    },
    etiquetas: [],
    dialogBultos: false,
    numBultos: 1,
  }),
  computed: {
    cambiotienda() {
      return this.$store.getters.getIdTienda;
    },
    cambiotiendaUid() {
      return this.$store.getters.getOpuid;
    },
    cambiotiendaCliCode() {
      return this.$store.state.userInfo.clicode;
    },
    isSalida() {
      return this.modo === 'salida';
    },
    total () {
      let total = 0;
      for (const item of Object.values(this.lineas)) {
        for (const talla of item) {
          total += talla.unid;
        }
      }
      return total;
    }
  },
  watch: {
    cambiotiendaUid(value) {
      this.opUid = value;
      if (!this.entradaSalidaManual) {
        const modo = this.isSalida ? 'salida' : 'entrada'
        if (this.isAlbaran) {
          this.$router.push({ name: 'Albaranes', query: { modo } })
        } else {
          this.$router.push({ name: 'Bultos', query: { modo } })
        }
      }
    },
    cambiotienda(value) {
      this.opId = value;
    },
    cambiotiendaCliCode(value) {
      this.clicode = value;
    },
    buscador(value) {
      this.filtrarArticulos(value)
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.ean = ''
    this.hayDiferencias = false
    document.getElementById("textEan").focus()
  },
  methods: {
    goBack() {
      const modo = this.isSalida ? 'salida' : 'entrada'
      if (this.entradaSalidaManual) {
        this.$router.push({ name: this.isSalida ? 'Salidas' : 'Entradas' })
      } else if (this.isAlbaran) {
        this.$router.push({ name: this.isSalida ? 'SalidasAlbaranes' : 'Albaranes', query: { modo } })
      } else {
        this.$router.push({ name: this.isSalida ? 'Salidas' : 'Bultos', query: { modo } })
      }
    },
    init() {
      this.sheet = false
      this.uidEntrada = crypto.randomUUID()
      this.opId = this.$store.getters.getIdTienda
      this.opUid = this.$store.getters.getOpuid
      this.clicode = this.$store.state.userInfo.clicode
      this.openedPanel = []
      // Si no tenemos uid es una entrada/salida manual sin odt asociada
      if (this.uid && this.uid !== undefined && this.uid !== '') {
        this.albaran = this.$store.getters.getAlbaranEnCurso
        if (this.albaran.barcode_uid) {
          // si tiene barcode es un bulto
          this.isAlbaran = false
        } else {
          this.isAlbaran = true
        }
        this.getDetalle()
      } else {
        this.entradaSalidaManual = true
        this.getAllOps()
      }
      if (this.isSalida && !this.entradaSalidaManual) {
        this.getAllOps()
      }
    },
    lecturaPistola() {
      this.tipoLectura = 0
      this.ean = ''
      document.getElementById("textEan").focus()
    },
    expandirContraer() {
      if (!this.expandir) {
        let contador = []
        for (let i = 0; i < Object.keys(this.lineas).length; i++) {
          contador.push(i)
        }
        this.openedPanel = contador
      } else {
        this.openedPanel = []
      }
      this.expandir = !this.expandir
    },
    getDetalle() {
      this.cargando = true
      if (this.isAlbaran) {
        albaranApiService.getAlbaranDetalle(this.opUid, this.uid, this.modo)
          .then((data) => {
            if (data.data.length > 0) {
              let result = data.data.reduce((acc, item) => { const k = item.art_id; if (!acc[k]) acc[k] = []; acc[k].push(item); return acc; }, {});
              // console.log(result)
              this.lineas = result
              this.getFotos(data.data.map(item => item.art_id).join(','))
              this.completarTallajeArticulos(data.info.articulos)
              // console.log('lineas', this.lineas)
            } else {
              this.cargando = false
            }
          })
          .catch((error) => {
            this.cargando = false
            this.$root.$emit('mostrarAlerta', 'Error al obtener los articulos', 'error')
            console.log('albaranApiService - getAlbaranDetalle ' + error)
          });
      } else {
        albaranApiService.getBultoDetalle(this.opUid, this.uid)
          .then((data) => {
            // console.log(data)
            if (data.data) {
              let result = Object.groupBy(data.data, ({ art_id }) => art_id);
              // console.log(result)
              this.lineas = result
              this.getFotos(data.data.map(item => item.art_id).join(','))
              this.completarTallajeArticulos(data.info.articulos)
            } else {
              this.cargando = false
            }

          })
          .catch((error) => {
            this.cargando = false
            this.$root.$emit('mostrarAlerta', 'Error al obtener los articulos', 'error')
            console.log('albaranApiService - getAlbaranDetalle ' + error)
          });
      }
    },
    completarTallajeArticulos(articulos) {
      articulos.forEach(tallaje => {
        let tallajeAux = []
        let tallasConUnidades = this.lineas[tallaje.art_id]
        tallaje.tallas.forEach(talla => {
          let tallaAux = talla
          tallaAux['unidInicial'] = 0
          tallaAux['unid'] = 0
          tallaAux['localizador'] = tallasConUnidades[0].localizador
          tallaAux['linUid'] = crypto.randomUUID()
          tallaAux['modelo'] = tallasConUnidades[0].modelo
          tallaAux['color'] = tallasConUnidades[0].color
          tallaAux['pvp'] = tallasConUnidades[0].pvp
          for (let i = 0; i < tallasConUnidades.length; i++) {
            if (talla.talla_interna === tallasConUnidades[i].talla_interna) {
              tallaAux = tallasConUnidades[i]
              tallaAux['tieneUnidades'] = true
              tallaAux['unidInicial'] = tallasConUnidades[i].unid
              tallaAux['linUid'] = crypto.randomUUID()
              this.totalInicial += tallasConUnidades[i].unid
              tallaAux['eans'] = talla.eans
              break
            }
          }
          tallajeAux.push(tallaAux)
        });
        this.lineas[tallaje.art_id] = tallajeAux
      });
      // CAMBIO: reiniciamos la lectura nada mas entrar al detalle del albaran
      for (var artic in this.lineas) {
        for (let x = 0; x < this.lineas[artic].length; x++) {
          this.lineas[artic][x].unid = 0
          this.lineas[artic][x].eanLeido = ''
        }
      }
      this.cargando = false
    },
    getFotos(ids) {
      tiendaApiService.getArticulosFotos(ids)
        .then(data => {
          if (data) {
            this.fotos = data.reduce((acc, curr) => (acc[curr.articulo] = curr, acc), {})
          }
        })
        .catch(error => {
          this.cargando = false
          this.fotos = {}
          console.log(error)
          this.$root.$emit('mostrarAlerta', 'Error obtener imagenes', 'error')
        })
    },
    searchByEanCode() {
      this.ean = this.ean.trim()
      if (this.ean.length > 0) {
        if (this.buscarEanLineas(this.ean)) {
          this.ean = ''
          this.audioOk.pause();
          this.audioOk.currentTime = 0;
          this.audioOk.play()
        } else {
          //si no esta en las lineas y tampoco al buscarlo damos error
          // en entradas/salidas manuales no hay albaran: se añade el articulo sin preguntar
          const confirmar = this.entradaSalidaManual
            ? Promise.resolve(true)
            : this.$root.$confirm.open('Añadir', 'El articulo no está en el albarán. ¿Deseas añadir el artículo?', { color: 'primary' })
          confirmar.then((confirm) => {
            if (confirm) {
              this.cargando = true
              tiendaApiService.getArticuloByEan(this.ean)
                .then(data => {
                  // console.log(data)
                  if (data) {
                    let tallas = []
                    let idArtic = data.id
                    data.tallas.forEach(element => {
                      if (element.eans && element.eans.length > 0) {
                        let unidades = 0
                        let eanAux = []
                        if (element.eans.some(item => item.ean.toString().trim() == this.ean.toString().trim())) {
                          unidades = 1
                          eanAux = [this.ean.toString().trim()]
                        } else {
                          eanAux = element.eans.map(o => o.ean)
                        }
                        let precio = 0
                        // TODO: optimizar la llamada para solo coger el precio de la op y no cargar todo el stock
                        // INFO: No hace falta añadir precio
                        // let objStock = element.stocks.filter(item => item.op.msopid.toString().trim() == this.opId.toString().trim())
                        // if (objStock.length > 0) {
                        //   precio = objStock[0].precio.precio
                        // }
                        tallas.push({
                          art_id: idArtic,
                          color: data.color,
                          descr: data.descripcionTpv,
                          eans: eanAux,
                          localizador: data.localizador,
                          modelo: data.modelo,
                          talla: element.talla,
                          talla_interna: element.tallaInterna + 1, //esta en base 1
                          linUid: crypto.randomUUID(),
                          unidInicial: 0,
                          unid: unidades,
                          pvp: precio,
                          added: true
                        })
                      }
                    });
                    this.fotos = Object.assign({ [idArtic]: data.fotos[0] }, this.fotos)
                    this.lineas = Object.assign({ [idArtic]: tallas }, this.lineas)
                    // console.log('lineas', this.lineas)
                    this.$root.$emit('mostrarAlerta', 'Articulo añadido', 'green')
                    this.cargando = false
                    this.openedPanel = [Object.keys(this.lineas).findIndex((element) => element === idArtic.toString())]
                    this.ean = ''
                    this.audioOk.pause();
                    this.audioOk.currentTime = 0;
                    this.audioOk.play()
                    this.totalLeido++
                    this.$forceUpdate()
                    this.keyRefresh += 1
                    this.$nextTick(() => {
                      document.getElementById(idArtic).scrollIntoView()
                    })
                  } else {
                    this.cargando = false
                    this.audioError.pause();
                    this.audioError.currentTime = 0;
                    this.audioError.play()
                    this.ean = ''
                    this.$root.$emit('mostrarAlerta', 'Ean no encotrado', 'error')
                  }
                })
                .catch(error => {
                  this.cargando = false
                  this.audioError.pause();
                  this.audioError.currentTime = 0;
                  this.audioError.play()
                  this.ean = ''
                  console.log(error)
                  this.$root.$emit('mostrarAlerta', 'Error al buscar el articulo', 'error')
                })
            }
          })
        }

      } else {
        this.audioError.pause();
        this.audioError.currentTime = 0;
        this.audioError.play()
        this.ean = ''
        this.$root.$emit('mostrarAlerta', 'Ean vacio', 'error')
      }
    },
    onEanScanned(ean) {
      this.ean = ean
      this.searchByEanCode()
    },
    buscarEanLineas(ean) {
      let contador = 0
      for (var artic in this.lineas) {
        for (let x = 0; x < this.lineas[artic].length; x++) {
          for (let y = 0; y < this.lineas[artic][x].eans.length; y++) {
            if (this.lineas[artic][x].eans[y] === ean) {
              document.getElementById(artic).scrollIntoView();
              // this.lineas[artic][x].eans = [ean] // INFO Ver porque hacia esto
              this.openedPanel = [contador]
              if (this.lineas[artic][x].tieneUnidades != undefined && this.lineas[artic][x].tieneUnidades) {
                this.lineas[artic][x].tieneUnidades = false
                this.lineas[artic][x].unid = 1
              } else {
                this.lineas[artic][x].unid++
              }
              this.lineas[artic][x].eanLeido = ean
              this.totalLeido++
              if (this.verDiff) {
                this.marcarDiferencias()
              }
              return true
            }
          }
        }
        contador++
      }
      return false
    },
    borrarEntrada() {
      this.$root.$confirm.open('Descartar', '¿Deseas descartar la entrada y empezar de cero?', { color: 'primary' }).then((confirm) => {
        if (confirm) {
          for (var artic in this.lineas) {
            for (let x = 0; x < this.lineas[artic].length; x++) {
              this.lineas[artic][x].unid = 0
              this.lineas[artic][x].eanLeido = ''
            }
          }
          if (this.verDiff) {
            this.marcarDiferencias()
          }
          this.totalLeido = 0
        }
      })
    },
    autoCompletar() {
      this.$root.$confirm.open('Autocompletar', '¿Deseas copiar las unidades de la entrada como lecturas?', { color: 'primary' }).then((confirm) => {
        if (confirm) {
          this.totalLeido = 0
          for (var artic in this.lineas) {
            for (let x = 0; x < this.lineas[artic].length; x++) {
              this.lineas[artic][x].unid = this.lineas[artic][x].unidInicial
              this.totalLeido += this.lineas[artic][x].unidInicial
            }
          }
          this.expandirContraer()
          if (this.verDiff) {
            this.marcarDiferencias()
          }
        }
      })
    },
    eliminarArticulo(idArtic) {
      this.$root.$confirm.open('Eliminar', '¿Deseas eliminar el articulo?', { color: 'primary' }).then((confirm) => {
        if (confirm) {
          delete this.lineas[idArtic]
          this.$forceUpdate()
        }
      })

    },
    filtrarArticulos() {
      if (this.buscador && this.buscador.length > 0) {
        let lineasFiltradas = []
        lineasFiltradas = Object.values(this.lineas).filter(item => {
          return (item[0].localizador.toString().indexOf(this.buscador) >= 0 ||
            item[0].modelo.toUpperCase().indexOf(this.buscador.toUpperCase()) >= 0
          )
        })
        console.log(lineasFiltradas)
        this.$refs.articulos.forEach(element => {
          if (lineasFiltradas.some(item => item[0].art_id == element.$el.id)) {
            element.$el.hidden = false
          } else {
            element.$el.hidden = true
          }
        });
      } else {
        this.$refs.articulos.forEach(element => {
          element.$el.hidden = false
        });
      }
    },
    // filtrarArticulos() {
    //   if (this.buscador && this.buscador.length > 0) {
    //     let lineasFiltradas = []
    //     lineasFiltradas = Object.values(this.lineas).filter(item =>{
    //       return (item[0].localizador.toString().indexOf(this.buscador) === 0 || 
    //               item[0].modelo.toUpperCase().indexOf(this.buscador.toUpperCase()) === 0
    //             )
    //     })
    //     console.log(lineasFiltradas)
    //     let encontrado = false
    //     this.$refs.articulos.forEach(element => {
    //       if (lineasFiltradas.some(item => item[0].art_id == element.$el.id )) {
    //         element.$el.hidden = false
    //         encontrado = true
    //       } else {
    //         element.$el.hidden = true
    //       }
    //     });
    //     if (!encontrado && this.buscador.length >= 13) {
    //       // puede ser un ean miramos que se un ean de los que ya estan sino hay que añadir el articulo
    //       this.$refs.articulos.forEach(element => {
    //         element.$el.hidden = false
    //       })
    //       if (!this.buscarEanLineas(this.buscador)) {
    //         this.ean = this.buscador
    //         this.searchByEanCode() 
    //       } else {
    //         this.ean = ''
    //         this.audioOk.pause();
    //         this.audioOk.currentTime = 0;
    //         this.audioOk.play()
    //         this.buscador = ''
    //       }
    //     }
    //   } else {
    //     this.$refs.articulos.forEach(element => {
    //         element.$el.hidden = false
    //     });
    //   }
    // },
    clearBuscador() {
      this.$refs.articulos.forEach(element => {
        element.$el.hidden = false
      });
    },
    /**
     * Verifica si hay diferencias en las unidades de los articulos
     */
    marcarDiferencias() {
      if ( this.verDiff ) {
        this.hayDiferencias = false
        this.cargando = true
        let contador = []
        let i = 0
        this.$refs.articulos.forEach(element => {
          if (this.lineas[Object.keys(this.lineas)[i]].some(item => item.unid !== item.unidInicial)) {
            this.hayDiferencias = true
            element.$el.style.backgroundColor = '#ffedd2'
            contador.push(i)
          } else {
            element.$el.style.backgroundColor = 'white'
          }
          i++
        })
        this.openedPanel = contador
        this.cargando = false
      } else {
        this.hayDiferencias = false
        this.$refs.articulos.forEach(element => {
           element.$el.style.backgroundColor = 'white'
        });
      }
    },
    verificarEntrada() {
      this.$root.$confirm.open('Enviar', '¿Deseas registrar la entrada?', { color: 'primary' }).then((confirm) => {
        if (confirm) {
          if (!this.entradaSalidaManual) {
            // antes de enviar marcamos las diferencias y si las hay volvemos a preguntart la confirmación
            if (!this.verDiff) {
              this.verDiff = true
            }
            this.marcarDiferencias()
            if (this.hayDiferencias) {
              this.$root.$confirm.open('Enviar', 'Hay diferencias en la entrada ¿Aun así deseas enviarla?', { color: 'primary' }).then((confirm) => {
                if (confirm) {
                  this.enviarEntrada()
                }
              })
            } else {
              this.enviarEntrada()
            }
          } else {
             if (this.tiendaOrigen.id !=='' && this.tiendaOrigen.id !== null) {
              this.enviarEntrada()
             } else {
              this.$root.$emit('mostrarAlerta', 'Debes seleccionar una tienda de origen', 'error')
             }
          }
        }
      })
    },
    enviarEntrada() {
      // console.log('enviarEntrada', this.lineas)
      this.cargando = true
      let entrada = []
      entrada.push(this.opUid)
      entrada.push(this.opId)
      entrada.push(this.clicode)
      entrada.push(this.$store.state.userInfo.codVendedor)

      if (!this.entradaSalidaManual) {
        entrada.push(this.albaran.origen_id)
        entrada.push(this.albaran.origen_cod)
      } else {
        entrada.push(this.tiendaOrigen.id)
        entrada.push(this.tiendaOrigen.clicode)
      }
      
      if (!this.isAlbaran) {
        entrada.push(this.albaran.barcode)
      } else {
        entrada.push("")
      }
      entrada.push(this.albaran.albaran_id)
      entrada.push(this.uidEntrada) //mandamos un uid de la netrada para evitar errores y duplicidades. lo mismo con las lineas
      for (var artic in this.lineas) {
        for (let x = 0; x < this.lineas[artic].length; x++) {
          if (this.lineas[artic][x].unid > 0) {
            entrada.push({
              tallaInterna: this.lineas[artic][x].talla_interna,
              tallaExterna: this.lineas[artic][x].talla,
              unidades: this.lineas[artic][x].unid,
              ean: this.lineas[artic][x].eanLeido,
              idArtic: artic,
              precio: this.lineas[artic][x].pvp,
              linUid: this.lineas[artic][x].linUid
            })
          }
        }
      }
      albaranApiService.enviarEntrada(entrada)
        .then(() => {
          this.cargando = false
          this.$root.$emit('mostrarAlerta', 'Entrada registrada con éxito', 'green')
          this.$router.push({ name: 'Entradas' });
        })
        .catch(error => {
          this.cargando = false
          this.$root.$emit('mostrarAlerta', 'Error al enviar la entrada', 'error')
          console.log('alabaranApiService - enviarEntrada ' + error)
          this.$router.push({ name: 'Entradas' });
        })
    },
    borrarSalida(){
      this.$root.$confirm.open('Descartar', '¿Deseas descartar las lecturas?', { color: 'primary' }).then((confirm) => {
        if (confirm) {
          this.lineas = {}
        }
      })
    },
    verificarSalida() {
      if (this.entradaSalidaManual && this.tiendaDestino.id =='' && this.tiendaDestino.id == null) {
        this.$root.$emit('mostrarAlerta', 'Debe seleccionar la tienda de destino', 'error')
      } else {
        this.$root.$confirm.open('Enviar', '¿Deseas registrar la salida?', { color: 'primary' }).then((confirm) => {
          if (confirm) {
            if (!this.entradaSalidaManual) {
              // antes de enviar marcamos las diferencias y si las hay volvemos a preguntar la confirmación
              if (!this.verDiff) {
                this.verDiff = true
              }
              this.marcarDiferencias()
              if (this.hayDiferencias) {
                this.$root.$confirm.open('Enviar', 'Hay diferencias en la salida ¿Aun así deseas enviarla?', { color: 'primary' }).then((confirm) => {
                  if (confirm) {
                    this.pedirBultos()
                  }
                })
              } else {
                this.pedirBultos()
              }
            } else {
              this.pedirBultos()
            }
          }
        })
      }
    },
    pedirBultos() {
      this.numBultos = 1
      this.dialogBultos = true
    },
    confirmarBultos() {
      if (this.numBultos < 1) {
        return
      }
      this.dialogBultos = false
      this.enviarSalida()
    },
    enviarSalida() {
      if (!this.entradaSalidaManual) {
        this.tiendaDestino.id = this.albaran.destino_tienda_id
        this.tiendaDestino.clicode = this.albaran.destino_tienda_cod
      }
      this.cargando = true
      let salida = []
      salida.push(this.opUid)
      salida.push(this.opId)
      salida.push(this.tiendaDestino.id)
      salida.push(this.clicode)
      salida.push(this.tiendaDestino.clicode)
      salida.push(this.$store.state.userInfo.codVendedor)
      if (!this.entradaSalidaManual) {
        salida.push(this.albaran.odt_id)
      } else {
        salida.push('')
      }
      salida.push(this.numBultos)
      for (var artic in this.lineas) {
        for (let x = 0; x < this.lineas[artic].length; x++) {
          if (this.lineas[artic][x].unid > 0) {
            salida.push({
              tallaInterna: this.lineas[artic][x].talla_interna,
              tallaExterna: this.lineas[artic][x].talla,
              unidades: this.lineas[artic][x].unid,
              ean: this.lineas[artic][x].eans[0],
              idArtic: artic,
              precio: this.lineas[artic][x].pvp
            })
          }
        }
      }
      albaranApiService.enviarSalida(salida)
        .then(data => {
          // el backend devuelve un SSCC por bulto (las versiones antiguas devolvian solo uno)
          const codigos = Array.isArray(data) ? data : [data]
          this.generarEtiquetaSSCC(codigos).then(() => {
            this.cargando = false
            this.$root.$emit('mostrarAlerta', 'Salida registrada con éxito', 'green')
            this.lineas = {}
            this.sheet = false
            this.$router.push({ name: 'Salidas' });
          })
          .catch((error) => {
            this.cargando = false
            this.tiendaDestino = {
              id: '',
              nombre: '',
              calle: '',
              cp: '',
              localidad: '',
              provincia: ''
            }
            this.$root.$emit('mostrarAlerta', 'Error al generar la etiqueta', 'error')
            console.log('generarEtiquetaSSCC ' + error)
            this.lineas = {}
            // aunque de error la etiqueta salimos para que no puedan darle salida de nuevo y la repitan
            this.sheet = false
            this.$router.push({ name: 'Salidas' });
          })
        })
        .catch(error => {
          this.tiendaDestino = {
            id: '',
            nombre: '',
            calle: '',
            cp: '',
            localidad: '',
            provincia: ''
          }
          this.cargando = false
          this.$root.$emit('mostrarAlerta', 'Error al enviar la Salida', 'error')
          console.log('alabaranApiService - enviarSalida ' + error)
          // aunque de error salimos porque aun asi se ha podido enviar por timeout (twister...) y no la repitan
          this.sheet = false
          this.$router.push({ name: 'Salidas' });
        })
    },
    detalleTienda (msopid) {
      let tiendas = this.shops
      let tiendaAux = tiendas.find((tienda) => msopid === tienda.id);
      if (tiendaAux) {
        return tiendaAux
      } else {
        return {id: '',
          nombre: '',
          calle: '',
          cp: '',
          localidad: '',
          provincia: ''
        }
      }
    },
    getAllOps() {
      opsApiService.getAllOps()
        .then(data => {
          if (data) {
            // console.log(data)
            data.forEach(el => {
              let opAux = {
                id: el.msopid,
                nombre: el.msopnombre,
                opuid: el.msopuid,
                wsid: el.msopparentworkspace,
                clicode: el.msopclicode,
                poblacion: el.msoppoblacion,
                calle: el.msopcalle
              }
              this.shops.push(opAux)
            }, this.shops);
          }
        })
        .catch(error => {
          console.log(error)
          this.$root.$emit('mostrarAlerta', 'Error al cargar las OPs', 'error')
        })
    },
    async generarEtiquetaSSCC(codigos) {
      try {
        // Generar un código de barras por bulto
        this.etiquetas = codigos.map(codigo => ({ sscc: codigo, img: this.generateBarcode(codigo) }))

        this.mostrarPdf = true

        // esperamos a que se pinten las etiquetas antes de clonarlas
        await this.$nextTick()

        let etiqueta = document.getElementById('etiqueta-pdf').cloneNode(true);

        etiqueta.style.display = 'block';

        // scrollX/scrollY a 0: si la pantalla esta desplazada html2canvas captura una zona vacia y el pdf sale en blanco
        await html2pdf()
          .from(etiqueta)
          .set({
                margin: 3,
                html2canvas: { scrollX: 0, scrollY: 0 },
              })
          .save(codigos[0]);
      } catch (error) {
        this.cargando = false
        this.tiendaDestino = {
          id: '',
          nombre: '',
          calle: '',
          cp: '',
          localidad: '',
          provincia: ''
        }
        this.etiquetas = []
        console.error('Error al generar la etiqueta:', error);
        this.$root.$emit('mostrarAlerta', 'Ocurrió un error al generar la etiqueta.', 'error')
      }
    },
    generateBarcode(code) {
      JsBarcode(this.$refs.barcodeCanvas, code, {
        // format: 'GS1-128',
        displayValue: true,
        fontSize: 12,
        margin: 10,
        height: 40,
        width: 2
      });
      return this.$refs.barcodeCanvas.toDataURL('image/png')
    },
  }
});
</script>
